// src/components/cosmic/utils/background-colors.ts
var colorMaps = {
  purple: {
    primary: "purple",
    accent: "pink",
    orb1: "purple-9/40",
    orb2: "pink-8/30",
    orb3: "purple-7/20",
    gradient: "from-purple-11/5 via-purple-10/10 to-purple-9/5",
    accent1: "purple-9/30",
    accent2: "pink-8/20",
    neuralPrimary: "purple-8/40",
    neuralSecondary: "pink-7/30",
    waveFrom: "purple-9/20",
    waveTo: "pink-8/10"
  },
  blue: {
    primary: "blue",
    accent: "cyan",
    orb1: "blue-9/40",
    orb2: "cyan-8/30",
    orb3: "blue-7/20",
    gradient: "from-blue-11/5 via-blue-10/10 to-cyan-9/5",
    accent1: "blue-9/30",
    accent2: "cyan-8/20",
    neuralPrimary: "blue-8/40",
    neuralSecondary: "cyan-7/30",
    waveFrom: "blue-9/20",
    waveTo: "cyan-8/10"
  },
  cyan: {
    primary: "cyan",
    accent: "blue",
    orb1: "cyan-9/40",
    orb2: "blue-8/30",
    orb3: "cyan-7/20",
    gradient: "from-cyan-11/5 via-cyan-10/10 to-blue-9/5",
    accent1: "cyan-9/30",
    accent2: "blue-8/20",
    neuralPrimary: "cyan-8/40",
    neuralSecondary: "blue-7/30",
    waveFrom: "cyan-9/20",
    waveTo: "blue-8/10"
  },
  pink: {
    primary: "pink",
    accent: "purple",
    orb1: "pink-9/40",
    orb2: "purple-8/30",
    orb3: "pink-7/20",
    gradient: "from-pink-11/5 via-pink-10/10 to-purple-9/5",
    accent1: "pink-9/30",
    accent2: "purple-8/20",
    neuralPrimary: "pink-8/40",
    neuralSecondary: "purple-7/30",
    waveFrom: "pink-9/20",
    waveTo: "purple-8/10"
  },
  indigo: {
    primary: "indigo",
    accent: "blue",
    orb1: "indigo-9/40",
    orb2: "blue-8/30",
    orb3: "indigo-7/20",
    gradient: "from-indigo-11/5 via-indigo-10/10 to-blue-9/5",
    accent1: "indigo-9/30",
    accent2: "blue-8/20",
    neuralPrimary: "indigo-8/40",
    neuralSecondary: "blue-7/30",
    waveFrom: "indigo-9/20",
    waveTo: "blue-8/10"
  },
  green: {
    primary: "green",
    accent: "cyan",
    orb1: "green-9/40",
    orb2: "cyan-8/30",
    orb3: "green-7/20",
    gradient: "from-green-11/5 via-green-10/10 to-cyan-9/5",
    accent1: "green-9/30",
    accent2: "cyan-8/20",
    neuralPrimary: "green-8/40",
    neuralSecondary: "cyan-7/30",
    waveFrom: "green-9/20",
    waveTo: "cyan-8/10"
  },
  orange: {
    primary: "orange",
    accent: "red",
    orb1: "orange-9/40",
    orb2: "red-8/30",
    orb3: "orange-7/20",
    gradient: "from-orange-11/5 via-orange-10/10 to-red-9/5",
    accent1: "orange-9/30",
    accent2: "red-8/20",
    neuralPrimary: "orange-8/40",
    neuralSecondary: "red-7/30",
    waveFrom: "orange-9/20",
    waveTo: "red-8/10"
  },
  // The theme's own primary and accent colours, so a custom brand glows in its
  // brand rather than a neutral grey. The accents build `bg-primary/30` and
  // `bg-accent/20` from `accent1` and `accent2`.
  custom: {
    primary: "primary",
    accent: "accent",
    orb1: "primary/40",
    orb2: "accent/30",
    orb3: "primary/20",
    gradient: "from-primary/5 via-accent/10 to-primary/5",
    accent1: "primary/30",
    accent2: "accent/20",
    neuralPrimary: "primary/40",
    neuralSecondary: "accent/30",
    waveFrom: "from-primary/20",
    waveTo: "to-accent/10"
  }
};
export {
  colorMaps
};
